import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GiFinSimulacaoModel } from 'src/app/dominio/gi-fin-simulacao-model';
import { Cliente } from 'src/app/models/cliente';
import { Pedido } from 'src/app/models/pedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-nova-simulacao-modal',
  templateUrl: './nova-simulacao-modal.component.html',
  styleUrls: ['./nova-simulacao-modal.component.scss']
})
export class NovaSimulacaoModalComponent implements OnInit {
  cliente: Cliente = new Cliente();
  dadosPessoais: Cliente = new Cliente();
  temDadosPessoais: boolean = false;
  potencia: number;
  pedido: Pedido | null = null;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<NovaSimulacaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService
  ) {
    this.cliente = data.cliente;
    this.dadosPessoais = data.dadosPessoais;
    this.pedido = data.pedido;
    this.temDadosPessoais = data.temDadosPessoais;
    this.potencia = data.potencia;
  }

  ngOnInit() {
  }

  fechar() {
    this.dialogRef.close();
  }

  onSimulacaoCadastrada(event: GiFinSimulacaoModel) {
    this.dialogRef.close(event);
  }
}
